<!--Recherche par projet--------------------------------------------------------------------------------------------------------------------------------------------------------->						

<template>
	<v-container grid-list-md text-center v-if="$store.state.VueRechercheProjet">
		<v-layout wrap>
			<v-flex	xs12>
				<v-card color="grey lighten-5" height="auto">
					<v-card-title>
						<v-flex xs11 sm11 class="text-left">
							<h3>Recherche par projet</h3>
						</v-flex>
						<v-flex xs1 sm1>
							<v-btn text @click="rechercheMenu" class="text-right">X</v-btn>
						</v-flex>
					</v-card-title>
					<v-card-text>
						<v-container grid-list-md text-center>
							<v-layout wrap>
								<v-flex xs12 sm12>
									<v-autocomplete v-model="$store.state.projectReference" label="Nom de projet ggm" :items="this.$store.state.projects" filled
										v-on:change="loadProject($store.state.projectReference)">
									</v-autocomplete>
								</v-flex>
								<v-flex xs12 v-if="$store.state.projectReference!=null">
									<v-card-title>
										<v-flex xs12 text-left>
											<h5>Projet {{ $store.state.projectReference }} :</h5>
										</v-flex>
										<v-btn text v-if="!$store.state.titleChange" @click="titleChangeTrue($store.state.projectReference)" :elevation="10">Modifier la référence du projet</v-btn>
										<v-flex xs12 sm8 v-if="$store.state.titleChange">
											<v-flex text-left>
												<v-text-field 
													v-model=$store.state.projectReference
													label="Référence du projet"
													:placeholder="$store.state.projectReference"
													filled
												></v-text-field>
												<v-btn text v-if="$store.state.projectReference != ''" @click="projectTitleChange(tempProjectTitle, $store.state.projectReference)">Valider</v-btn>
												<v-btn text @click="titleChangeFalse">Annuler</v-btn>
											</v-flex>
										</v-flex>
									</v-card-title>	
							
									<v-flex xs12 sm12 v-for="(item) in this.$store.state.ggmProjectQuotationTitle" v-bind:key="item" class="ma-2 align-center">
										<v-btn class="ma-2" color="red" @click="quotationSelected(item)" dark>{{ item }}
											<v-icon dark right>mdi-file-pdf</v-icon>
										</v-btn>
										<v-btn class="ma-2" color="blue"
											@click="quotationConvertLink(item)" dark>
											<v-icon left>mdi-file-swap</v-icon>
											{{ item }} -> ASW
										</v-btn>
										<v-btn class="ma-2" color="green dark"
											@click="quotationXlsx(item)" dark>
											<v-icon left>mdi-file-swap</v-icon>
											{{ item }} -> Excel
										</v-btn>
									</v-flex>
									<v-card-title>
										<h5>Articles :</h5>
										<v-spacer></v-spacer>
										<v-text-field
											v-model="searchQuotations"
											append-icon="mdi-magnify"
											label="Recherche"
											single-line
											hide-details>
										</v-text-field>															
									</v-card-title>
									<v-data-table
										:headers="this.$store.state.ProjectsHeaders"
										:items="$store.state.ggmProject"
										:search="searchQuotations"
										disable-pagination
										hide-default-footer
										item-key="name"
										group-by="QUOTATION_NUMBER"
										class="elevation-1"
									></v-data-table>
								</v-flex>
							</v-layout>
						</v-container>
					</v-card-text>
					<v-card-actions>
						<v-btn text @click="rechercheMenu" class="align-end">Retour</v-btn>
					</v-card-actions>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>
<script>
	import axios from 'axios';

	export default {
		name: "RechercheParNoOffre",
		tempProjectTitle: "",

		data: function () {
			return {
				searchQuotations: null,
            }
        },
		methods: {
            rechercheMenu: function () {
                this.$store.state.VueRechercheMenu = true;
                this.$store.state.VueRechercheArticle = false;
                this.$store.state.VueRechercheDesignation = false;
                this.$store.state.VueRechercheOffre = false;
                this.$store.state.VueRechercheProjet = false;
            },
			loadArticleQuotations: function (selected) {
				if (selected.length) {
					this.$store.state.designationQuotations = true;
					var link = "http://domoserver.ddns.net/gigamedia1/loadArticleQuotations.php?edi_code=" + encodeURIComponent(selected[0].EDI_Code);
					axios.get(link).then(response => (this.$store.state.ArticleQuotations = response.data));
				}
				else {
					this.$store.state.designationQuotations = false;
				}
			},
			loadQuotation: function (quotationReference) {
				this.convertOk = false;
				quotationReference = quotationReference.replace("&", "%&"); // échappe le caractère "&" dans l'URL
				this.$store.state.quotationNumberToASW = quotationReference;
				var link = "http://domoserver.ddns.net/gigamedia1/loadQuotation.php?quotationReference=" + encodeURIComponent(quotationReference);
				axios.get(link).then(response => (this.$store.state.ConectisQuotation = response.data));
			},
			loadProject: function (projectReference) {
				projectReference = projectReference.replace("&", "%&"); // échappe le caractère "&" dans l'URL
				link = "http://domoserver.ddns.net/gigamedia1/loadQuotationsFiles.php?projectReference=" + encodeURIComponent(projectReference);
				axios.get(link).then(response => (this.$store.state.ggmProjectQuotationTitle = response.data));
				var link = "http://domoserver.ddns.net/gigamedia1/loadProject.php?projectReference=" + encodeURIComponent(projectReference);
				axios.get(link).then(response => (this.$store.state.ggmProject = response.data));
			},
			loadStockConectis: function (edi_code) {
				this.$store.state.stockConectis.QUANTITE = null;
				this.$store.state.stockConectis.REFERENCE_ASW = null;
				this.$store.state.stockConectis.REFERENCE_CONECTIS = null;
				this.$store.state.stockConectis.stock_ok = false;
				this.$store.state.stockConectis_is_loading = true;
				var link = "http://domoserver.ddns.net/gigamedia1/loadArticleData.php?edi_code=" + encodeURIComponent(edi_code);
				axios.get(link).then(response => (this.$store.state.dataArticle = response.data));
				link = "http://domoserver.ddns.net/gigamedia1/loadArticleQuotations.php?edi_code=" + encodeURIComponent(edi_code);
				axios.get(link).then(response => (this.$store.state.ArticleQuotations = response.data));
				link = "http://domoserver.ddns.net/gigamedia1/loadStockConectis.php?reference=" + encodeURIComponent(edi_code);
				axios.get(link).then(response => (this.$store.state.stockConectis = response.data,
					setTimeout(() => {
						this.$store.state.stockConectis_is_loading = false;
					}, 15000),
					this.$store.state.stockConectis_is_loading = !response.data.stock_ok));
			},
			quotationSelected: function (quotationFilename) {
				var pdf = "http://domoserver.ddns.net/gigamedia1/quotations/" + encodeURIComponent(quotationFilename) + ".pdf";
				window.open(pdf, "_blank");
			},
			quotationConvertLink: function (reference) {
				this.$store.state.quotationNumberToASW = reference;
				this.$store.state.quotationReference = reference;
				this.convertOk = false;
				var link = "http://domoserver.ddns.net/gigamedia1/loadQuotationByFileName.php?quotationFilename=" + encodeURIComponent(reference);
				axios.get(link).then(response => (this.$store.state.ConectisQuotation = response.data));
				this.$store.state.active = 1; //select convert tab
			},
			quotationXlsx: function (quotationFilename) {
				var quotationFilenameXlsx = quotationFilename + ".xlsx";
				var link = "http://domoserver.ddns.net/gigamedia1/XlsxWriter/quotationXlsx.php?quotationFileName=" + encodeURIComponent(quotationFilename);
				axios.get(link).then(response => {
					this.dataXlsx = response.data;
					var xlsx = "http://domoserver.ddns.net/gigamedia1/quotations/" + encodeURIComponent(quotationFilenameXlsx);
					window.open(xlsx, "window1", "");
				});
			},
			titleChangeTrue: function (projectTitle) {
				this.tempProjectTitle = projectTitle;
				this.$store.state.titleChange = true;
			},
			titleChangeFalse: function () {
				this.$store.state.titleChange = false;
			},
			projectTitleChange: function(tempProjectTitle, projectReference) {
				this.$store.state.api_status = "nok";
				var link = 'http://domoserver.ddns.net/gigamedia/projectTitleSave.php?oldTitle='+encodeURIComponent(tempProjectTitle)+'&newTitle='+encodeURIComponent(projectReference);
				axios.get(link).then(response => (this.$store.state.projects = response.data));	
				this.$store.state.titleChange = false;
			},
        }
    }
</script>
